import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: '',
        perms:[],
        themecolor:'red',
        admin:{},
    },
    getters:{

        getPermByIdentify: (state) => (identify) => {
            if(state.perms.length===0&&!sessionStorage.getItem('perms')){
                return null;
            }
            if(state.perms.length===0){
                state.perms=JSON.parse(sessionStorage.getItem('perms'));
            }
            return state.perms.find(perm => perm.identify === identify);
        },
        getToken(state){
            if(!state.token&&!sessionStorage.getItem('token')){
                return null;
            }
            if(!state.token){
                state.token=sessionStorage.getItem('token');
            }
            return state.token;
        },
        getAdmin(state) {
            if (!state.admin.id && !sessionStorage.getItem('admin')) {
                return null;
            }
            if (!state.admin.id) {
                state.admin = JSON.parse(sessionStorage.getItem('admin'));
            }
            return state.admin;
        },
    },
    mutations: {
        setToken(state,token){
            state.token=token;
            sessionStorage.setItem('token',token);
        },
        setPerms(state,perms){
            state.perms=perms;
            sessionStorage.setItem('perms',JSON.stringify(perms));
        },
        clearStore(state){
            state.token='';
            state.perms=[];
            state.admin= {};
            sessionStorage.clear();
        },
        setAdmin(state,admin){
            state.admin=admin;
            sessionStorage.setItem('admin',JSON.stringify(admin));
        },
        setColor(state,color){
            state.themecolor=color;
        }
    },
    actions: {
        setToken({commit},token){
            commit('setToken',token);
            sessionStorage.setItem('token',token);
        },
        setPerms({commit},perms){
            commit('setPerms',perms);
            sessionStorage.setItem('perms',JSON.stringify(perms));
        },
        setAdmin({commit},admin){
            commit('setAdmin',admin);
        },
    }
})
